import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComment = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 3.75a2 2 0 0 1 2-2h12.5a2 2 0 0 1 2 2v9.5a2 2 0 0 1-2 2h-3a2 2 0 0 0-1.6.8L10 18.25l-1.65-2.2a2 2 0 0 0-1.6-.8h-3a2 2 0 0 1-2-2v-9.5Z"
	})]
});
const ForwardRef = forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
